module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("E106 Compliance Request")]), _vm._v(" "), (_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "header": "Request"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "compliance"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Project Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.projectDescription),
      expression: "complianceDto.projectDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.complianceDto.projectDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "projectDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Property Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "addPropertyInfo",
      "disabled": _vm.isNew
    },
    on: {
      "click": function($event) {
        _vm.addNewPropertyInfo()
      }
    }
  }, [_vm._v("Add Property Information")])])]), _vm._v(" "), _c('div', [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.propertyInfoGridSpec.tableData,
      "columns": _vm.propertyInfoGridSpec.columns,
      "options": _vm.propertyInfoGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.editPropertyInformation(props.row)
            }
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePropertyInformation(props.row.e106compliancePropertyInformationId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('h4', [_vm._v("PLSS Locations")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button3",
      "disabled": _vm.isNew
    },
    on: {
      "click": function($event) {
        _vm.showSectionModal()
      }
    }
  }, [_vm._v("Add PLSS Locations")]), _vm._v(" "), _c('modal', {
    attrs: {
      "title": "Add Sections(s)",
      "effect": "fade/zoom",
      "value": _vm.sectionModalShow
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add PLSS Locations")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    attrs: {
      "showTitle": false
    },
    on: {
      "savePlss": _vm.savePlssE106Compliance
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSectionModal
    }
  }, [_vm._v("Exit")])])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.plssLocationGridSpec.tableData.length > 0),
      expression: "plssLocationGridSpec.tableData.length > 0"
    }]
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row.e106compliancePlssLocationId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('h4', [_vm._v("Land Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Description of Current Land Use")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.currentLandUse),
      expression: "complianceDto.currentLandUse"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.complianceDto.currentLandUse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "currentLandUse", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Nature of Any Previous Disturbances")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.previousDisturbances),
      expression: "complianceDto.previousDisturbances"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.complianceDto.previousDisturbances)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "previousDisturbances", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.isPublicSubmission) ? _c('div', {
    attrs: {
      "id": "publicE106Contact"
    }
  }, [_c('hr', {
    staticClass: "form-group",
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterFirstName),
      expression: "complianceDto.submitterFirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterFirstName",
      "type": "text",
      "placeholder": "Submitter First Name"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterFirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterLastName),
      expression: "complianceDto.submitterLastName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterLastName",
      "type": "text",
      "placeholder": "Submitter Last Name"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterLastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterEmail),
      expression: "complianceDto.submitterEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterEmail",
      "type": "text",
      "placeholder": "user@example.com"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Submitter Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complianceDto.submitterPhone),
      expression: "complianceDto.submitterPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "submitterPhone",
      "type": "tel",
      "placeholder": "123-45-6789"
    },
    domProps: {
      "value": (_vm.complianceDto.submitterPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.complianceDto, "submitterPhone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "form-group",
    staticStyle: {
      "border": "solid 1px #cccccc"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-2 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveCompliance
    }
  }, [_vm._v(_vm._s(_vm.isNew ? "Create" : "Save"))])]) : _vm._e()])])]), _vm._v(" "), _c('modal2', {
    ref: "propertyInfoModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Property Information")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['propertyInfoModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.streetAddress),
      expression: "selectedPropertyInfo.streetAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.streetAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "streetAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.city),
      expression: "selectedPropertyInfo.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("County")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.county),
      expression: "selectedPropertyInfo.county"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.county)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "county", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Zip Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.zipCode),
      expression: "selectedPropertyInfo.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "zipCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Lot")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.lot),
      expression: "selectedPropertyInfo.lot"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.lot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "lot", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.block),
      expression: "selectedPropertyInfo.block"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.block)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "block", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Date of Construction")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.constructionDate),
      expression: "selectedPropertyInfo.constructionDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.constructionDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "constructionDate", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Dates of Additions/Modifications")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.additionsModificationsDates),
      expression: "selectedPropertyInfo.additionsModificationsDates"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.additionsModificationsDates)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "additionsModificationsDates", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label text-label"
  }, [_vm._v("Proposed Changes and Brief History of the Building")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyInfo.proposedChangesBriefHistory),
      expression: "selectedPropertyInfo.proposedChangesBriefHistory"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.selectedPropertyInfo.proposedChangesBriefHistory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyInfo, "proposedChangesBriefHistory", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.savePropertyInformation()
      }
    }
  }, [_vm._v("Save")])]) : _vm._e()])])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents",
      "disabled": _vm.isNew
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(!_vm.isNew) ? _c('documents', {
    ref: "documents",
    attrs: {
      "parentId": _vm.e106complianceId,
      "formDisabled": _vm.formDisabled
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.isNew) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('mediaLetter', {
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdE106Letter,
      "parentId": _vm.e106complianceId
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": _vm.isNew
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.e106complianceWorkflowId,
      "parentId": _vm.e106complianceId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.project ? _vm.project.projectId : null,
      "e106complianceId": _vm.e106complianceId,
      "mediaTypeId": _vm.mediaTypeIdE106Letter,
      "parentId": _vm.e106complianceId
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6abebad0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/E106Compliance.vue
// module id = 954
// module chunks = 1